import * as Yup from 'yup';
import { SERVICE_OPTIONS } from '../types/partner';

export const accountSchema = Yup.object().shape({
  email: Yup.string()
    .email('Email không hợp lệ')
    .required('Email là bắt buộc'),
  password: Yup.string()
    .min(8, 'Mật khẩu phải có ít nhất 8 ký tự')
    .required('Mật khẩu là bắt buộc'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password')], 'Mật khẩu không khớp')
    .required('Xác nhận mật khẩu là bắt buộc')
});

export const businessSchema = Yup.object().shape({
  businessName: Yup.string()
    .required('Tên doanh nghiệp là bắt buộc'),
  website: Yup.string()
    .url('URL website không hợp lệ')
});

export const servicesSchema = Yup.object().shape({
  services: Yup.array()
    .min(1, 'Chọn ít nhất 1 dịch vụ')
    .max(3, 'Chỉ được chọn tối đa 3 dịch vụ')
    .required('Dịch vụ là bắt buộc')
});

export const teamSizeSchema = Yup.object().shape({
  teamSize: Yup.string()
    .required('Vui lòng chọn quy mô đội ngũ')
});

export const addressSchema = Yup.object().shape({
  hasNoFixedAddress: Yup.boolean(),
  address: Yup.string().when('hasNoFixedAddress', {
    is: false,
    then: () => Yup.string().required('Địa chỉ là bắt buộc'),
    otherwise: () => Yup.string().notRequired()
  })
}); 